<div class="py-12 lg:py-15 wrapper">
  <form
    action="#"
    [formGroup]="form"
    [autofocus]="true"
    autocomplete="off"
    (ngSubmit)="onSubmit(form)"
    class="relative w-full mx-auto flex flex-col max-w-[90%] md:max-w-[80%] bg-gray-50 rounded-br-[70px] lg:rounded-br-[160px]">
    <ng-container *ngIf="showNowOnafriqAlert">
      <ng-container *ngTemplateOutlet="nowOnafriqAlert"></ng-container>
    </ng-container>

    <div class="max-lg:hidden flex justify-end p-4" [ngClass]="{ 'mt-7': showNowOnafriqAlert }">
      <div class="group relative">
        <div
          class="hidden group-hover:block group-active:block bg-blue-400 rounded-l-lg rounded-br-lg p-2 w-40 absolute right-5 top-5">
          <span class="text-sm text-white font-normal leading-3"> We are currently only available in Uganda </span>
        </div>
        <img src="https://flagcdn.com/ug.svg" class="h-5 w-5 rounded-full" alt="country" />
      </div>
    </div>
    <div
      class="px-6 pt-3 pb-12 lg:pb-20 flex flex-col mx-auto lg:max-w-sm"
      [ngClass]="{ 'mt-12 lg:mt-0': showNowOnafriqAlert }">
      <span class="lg:text-2xl lg:leading-10 font-medium mb-7 lg:mb-[53px]">{{
        (savedUser$ | async)
          ? 'Welcome back' +
            ((savedUser$ | async)?.first_name ? ', ' + ((savedUser$ | async)?.first_name | titlecase) + '.' : '')
          : 'Login to your account'
      }}</span>
      <!--
    TODO: remove `codeInputReadonly`, `ugandaOnlyError`, `codeInputClicked` and `codeInputBlur`
    when Uganda is not the only supported country in production #ugandaOnly
  -->
      <bey-country-phone-number-input
        *ngIf="!(savedUser$ | async)"
        formControlName="phone"
        label="Phone number"
        [options]="countries"
        getElementId
        [control]="form.controls['phone']"
        [codeInputReadonly]="countries.length === 1"
        (codeInputClicked)="countries.length === 1 && (ugandaOnlyError = true)"
        (codeInputBlur)="countries.length === 1 && (ugandaOnlyError = false)"
        [ugandaOnlyError]="ugandaOnlyError"></bey-country-phone-number-input>

      <bey-input-pin
        label="PIN"
        class="w-full"
        formControlName="PIN"
        getElementId
        [control]="form.controls['PIN']"></bey-input-pin>
      <div class="text-xs text-gray-400 mt-2">
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy" class="text-blue-300">Privacy Policy</a> and
        <a href="https://policies.google.com/terms" class="text-blue-300">Terms of Service</a> apply.
      </div>
      <bey-button
        placeholder="Login"
        classList="w-full mt-5"
        [submit]="true"
        [isLoading]="loginIsLoading$ | async"
        getElementId
        getElementIdDescription="login"></bey-button>
      <a
        getElementId
        getElementIdDescription="forgot-pin"
        class="text-blue-400 font-medium my-8"
        routerLink="/phone-number"
        >Forgot PIN?</a
      >
      <a
        *ngIf="savedUser$ | async"
        getElementId
        getElementIdDescription="different-number"
        class="text-blue-400 font-medium my-8 cursor-pointer"
        (click)="changePhoneNumberClickHandler()"
        >Login with a different number</a
      >
      <!-- signup is disabled for now, TODO: remove this when signup is enabled -->
      <!-- <ng-template #noSavedUser>
        <span class="font-semibold text-base text-gray-900"
          >Don't have an account?
          <a getElementId getElementIdDescription="signup" class="text-blue-400" routerLink="/signup">Sign up</a></span
        >
      </ng-template> -->
    </div>
  </form>
</div>

<ng-template #nowOnafriqAlert>
  <div class="absolute -top-7 inset-x-0 px-3">
    <div
      class="flex items-center gap-4 p-4 max-w-sm mx-auto rounded-xl bg-blue-50 border-2 border-blue-200 shadow-[4px_4px_10px_0px_#002F381A]">
      <span class="bg-blue-500 text-white h-8 w-8 rounded-full flex justify-center items-center">
        <bey-exclamation-icon [height]="16" [width]="16" variant="currentColor"></bey-exclamation-icon>
      </span>
      <span class="flex-1 lg:text-lg font-medium text-center">Beyonic is now Onafriq! 🚀</span>
      <img width="16" height="16" src="assets/images/icons/x-close.svg" class="cursor-pointer" (click)="onXClick()" />
    </div>
  </div>
</ng-template>
